<template lang="pug">
.download-buttons(:class="$mq")
  img(
    src="@/assets/img/download-on-appstore.svg",
    title="Moonly pour iOS",
    @click="open('iOS', 'https://apps.apple.com/us/app/id1511574452')",
    alt="Télécharger dans l'App Store"
  )
  img(
    src="@/assets/img/google-play-badge.png",
    title="Moonly pour Android",
    @click="open('android', 'https://play.google.com/store/apps/details?id=com.moonlyapp.app')",
    alt="Disponible sur Google Play"
  )
</template>

<script>
export default {
  name: 'DownloadButtons',
  methods: {
    open (os, url) {
      this.$gtag.event('click', {
        event_category: 'external_link',
        event_label: 'appstore',
        value: os
      })
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/text';

.download-buttons {
  display: grid;

  &.phone {
    grid-template-columns: 200px;
    row-gap: 10px;
  }

  &.tablet-portrait {
    grid-template-columns: 250px;
    row-gap: 20px;
  }

  &.phone,
  &.tablet-portrait {
    grid-template-rows: repeat(2, auto);

    img {
      width: 100%;
    }
  }

  &.tablet-landscape,
  &.desktop,
  &.large-desktop {
    grid-template-rows: 75px;
    grid-template-columns: repeat(2, 260px);

    &.large-desktop {
      grid-template-rows: 150px;
      grid-template-columns: repeat(2, 520px);
    }
    justify-items: center;
    column-gap: 20px;

    img {
      height: 100%;
    }

    .label {
      grid-column: 1 / 3;
    }
  }

  img {
    cursor: pointer;
    $shadow: drop-shadow(5px 5px 10px rgba(black, 0.1));
    -webkit-filter: $shadow;
    filter: $shadow;
  }

  .label {
    @include text.normal;
    font-weight: 300;
    margin-top: 10px;
  }
}
</style>
